<template>
    <div :style="{marginLeft}">
        <!-- 这个是标题，不用管 -->
        <div v-if="item.itemName" class="item-name"></div>
        <!-- 区分一下可能会出现的几种参数形式 -->
        <!-- 1. 有type，说明参数为横排或竖排 -->
        <div
            v-else-if="item.type === 'landscape'"
            v-show="hideSameParam ? hideSameParam && !config.diff : true"
            class="item-subname"
            :class="{
                'light-same-param': !config.diff && lightSameParam
            }"
        >
            <p>
                <span
                    v-if="item.value[0] === '-'"
                    class="parameter-line"
                ></span>
                <span v-else>{{ item.value[0] | parseValue }}</span>
                <span
                    v-if="item.symbol[0] === '标配'"
                    class="parameter-std parameter-right"
                ></span>
                <span
                    v-if="item.symbol[0] === '选配'"
                    class="parameter-opt parameter-right"
                ></span>
                <span
                    v-if="item.symbol[0] === '-'"
                    class="parameter-line parameter-right"
                ></span>
                <template v-if="item.value[1]">
                    /
                    <span
                        v-if="item.value[1] === '-'"
                        class="parameter-line"
                    ></span>
                    <span v-else>{{ item.value[1] | parseValue }}</span>
                    <span
                        v-if="item.symbol[1] === '标配'"
                        class="parameter-std parameter-right"
                    ></span>
                    <span
                        v-if="item.symbol[1] === '选配'"
                        class="parameter-opt parameter-right"
                    ></span>
                    <span
                        v-if="item.symbol[1] === '-'"
                        class="parameter-line parameter-right"
                    ></span>
                </template>
            </p>
        </div>
        <div
            v-else-if="item.type === 'portrait'"
            v-show="hideSameParam ? hideSameParam && !config.diff : true"
            class="item-subname"
            :class="{
                'light-same-param': !config.diff && lightSameParam
            }"
        >
            <p v-for="(s, ii) in item.symbol" :key="ii">
                <span
                    v-if="s === '标配'"
                    class="parameter-std parameter-left"
                ></span>
                <span
                    v-if="s === '选配'"
                    class="parameter-opt parameter-left"
                ></span>
                <span v-if="s === '-'" class="parameter-line"></span>
                <span>{{ item.value[ii] | parseValue }}</span>
            </p>
        </div>
        <!-- 2. 有symbol，说明参数为竖排 -->
        <div
            v-else-if="item.symbol"
            v-show="hideSameParam ? hideSameParam && !config.diff : true"
            class="item-subname"
            :class="{
                'light-same-param': !config.diff && lightSameParam
            }"
        >
            <p>
                <span
                    v-if="item.symbol === '标配'"
                    class="parameter-std parameter-left"
                ></span>
                <span
                    v-if="item.symbol === '选配'"
                    class="parameter-opt parameter-left"
                ></span>
                <span v-if="item.value === '-'" class="parameter-line"></span>
                <span v-else>{{ item.value | parseValue }}</span>
            </p>
        </div>
        <!-- 3. 直接展示value -->
        <div
            v-else
            v-show="hideSameParam ? hideSameParam && !config.diff : true"
            class="item-subname text-center"
            :class="{
                'light-same-param': !config.diff && lightSameParam
            }"
        >
            <span v-if="item.value === '-'" class="parameter-line"></span>
            <span v-else>{{ item.value }}</span>
        </div>
    </div>
</template>

<script>
/**
 * @file
 * @author
 */
export default {
    props: {
        item: Object,
        config: Object,
        lightSameParam: Boolean,
        hideSameParam: Boolean,
        marginLeft: String
    },
    filters: {
        // 是否展示标配/选配这两个文字
        parseValue(value) {
            return value === '选配' || value === '标配' ? '' : value;
        }
    }
};
</script>

<style lang="less" scoped>
.border(@top, @right, @bottom, @left) {
    border-width: @top @right @bottom @left;
    border-style: solid;
    border-color: #EEEEEE;
}
.item-name {
    width: 230px;
    height: 42px;
    background: #f8f8f8;
}
.parameter-opt,
.parameter-std {
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 1px solid #333333;
    border-radius: 50%;
}
.parameter-right {
    margin-left: 2px;
}
.parameter-left {
    margin-right: 2px;
}
.parameter-std {
    background: #333333;
}
.parameter-line {
    display: inline-block;
    width: 11px;
    margin-bottom: 6px;
    border-bottom: 1px solid #333333;
}
.item-subname {
    width: 230px;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 47px;
    padding: 12px 0 12px 20px;
    .border(0, 1px, 0, 0);
    background: #ffffff;
    line-height: 22px;
    &.text-center {
        display: block;
        text-align: center;
        padding-left: 0;
    }
}
.light-same-param {
    background: #feffe3 !important;
}
</style>
